// src/index.tsx
import {
  createContext,
  useContext,
  useReducer,
  useMemo,
  useCallback
} from "react";
import { jsx } from "react/jsx-runtime";
var RBACContext = createContext({});
var reducer = (state, action) => {
  switch (action.type) {
    case "SET_USER_ROLE" /* SET_USER_ROLE */: {
      return {
        ...state,
        userRole: action.payload
      };
    }
    case "SET_PERMISSIONS" /* SET_PERMISSIONS */: {
      return {
        ...state,
        permissions: action.payload
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};
var RBACProvider = ({
  children,
  userRole = "",
  permissions = []
}) => {
  const [RBACState, dispatch] = useReducer(reducer, {
    userRole,
    permissions
  });
  const setUserRole = (payload) => dispatch({
    type: "SET_USER_ROLE" /* SET_USER_ROLE */,
    payload
  });
  const setPermissions = (payload) => dispatch({
    type: "SET_PERMISSIONS" /* SET_PERMISSIONS */,
    payload
  });
  const hasPermission = (permission) => {
    var _a;
    return (_a = RBACState == null ? void 0 : RBACState.permissions) == null ? void 0 : _a.includes(permission);
  };
  const hasPermissions = (permissions2) => permissions2.every((permission) => hasPermission(permission));
  const hasAnyPermission = useCallback((permissions2) => permissions2.some((permission) => hasPermission(permission)), [RBACState]);
  const value = useMemo(() => ({
    ...RBACState,
    hasPermission,
    hasPermissions,
    hasAnyPermission,
    setUserRole,
    setPermissions
  }), [RBACState]);
  return /* @__PURE__ */ jsx(RBACContext.Provider, {
    value,
    children
  });
};
var CanShow = ({
  permissions = [],
  children
}) => /* @__PURE__ */ jsx(RBACContext.Consumer, {
  children: ({
    hasPermissions
  }) => hasPermissions(permissions) ? children : /* @__PURE__ */ jsx("div", {})
});
var useRBAC = () => useContext(RBACContext);
var useHasPermission = (permission) => {
  var _a;
  return (_a = useRBAC()) == null ? void 0 : _a.hasPermission(permission);
};
var useHasPermissions = (permissions) => {
  var _a;
  return (_a = useRBAC()) == null ? void 0 : _a.hasPermissions(permissions);
};
var useHasAnyPermission = (permissions) => {
  var _a;
  return (_a = useRBAC()) == null ? void 0 : _a.hasAnyPermission(permissions);
};
export {
  CanShow,
  RBACProvider,
  useHasAnyPermission,
  useHasPermission,
  useHasPermissions,
  useRBAC
};
